import promise from 'promise';

import api from 'app/shared/utils/api';
import DispatchConstants from 'app/shared/constants/DispatchConstants';

// service
import appLogger from 'app/shared/loggers/appLogger';

const SchedulerActions = {
    update(listingId, schedule = {}) {
        return (dispatch, getState) => dispatch(api.users.scheduler.update(listingId, schedule))
            .then((result) => {
                const { error: errorRMWModel, success } = result;

                if (success === false) {
                    return promise.reject(errorRMWModel);
                }

                return dispatch({
                    type: DispatchConstants.SCHEDULER_UPDATE_SUCCESS,
                    payload: result.response,
                });
            })
            .catch((errorRMWModel) => {
                appLogger.logError({
                    message: errorRMWModel.message,
                    context: 'SchedulerActions.update',
                    user: getState().user,
                });
            });
    },
};

export default SchedulerActions;
